import { render, staticRenderFns } from "./MaturityLevel.vue?vue&type=template&id=b8124eb4&scoped=true"
import script from "./MaturityLevel.vue?vue&type=script&lang=js"
export * from "./MaturityLevel.vue?vue&type=script&lang=js"
import style0 from "./MaturityLevel.vue?vue&type=style&index=0&id=b8124eb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8124eb4",
  null
  
)

export default component.exports